import { X } from 'lucide-react';
import { youTubeThumbnailUrl } from '../../shared/youtube-url';
import { formatRelativeDate } from '../lib/format';
import type { HistoryEntry } from '../lib/storage';
import { LANG_NAMES } from '../lib/texts';
import { Thumbnail } from './Thumbnail';

export interface HistoryListProps {
  entries: HistoryEntry[];
  onOpen: (entry: HistoryEntry) => void;
  onRemove: (entry: HistoryEntry) => void;
}

export function HistoryList({ entries, onOpen, onRemove }: HistoryListProps) {
  if (entries.length === 0) return null;
  return (
    <section className="history glass" aria-labelledby="history-title">
      <h2 id="history-title" className="section-title">
        Zuletzt zusammengefasst
      </h2>
      <ul className="history__list">
        {entries.map((entry) => (
          <li key={`${entry.videoId}:${entry.lang}`} className="history__item">
            <button type="button" className="history__open" onClick={() => onOpen(entry)}>
              <Thumbnail
                className="history__thumb"
                src={youTubeThumbnailUrl(entry.videoId, 'mqdefault')}
                width={112}
                height={63}
              />
              <span className="history__text">
                <span className="history__title">{entry.title || entry.videoId}</span>
                <span className="history__meta">
                  <span className="lang-badge" title={LANG_NAMES[entry.lang]}>
                    <span aria-hidden="true">{entry.lang.toUpperCase()}</span>
                    <span className="sr-only">{LANG_NAMES[entry.lang]}</span>
                  </span>
                  {[entry.channel, formatRelativeDate(entry.viewedAt)].filter(Boolean).join(' · ')}
                </span>
              </span>
            </button>
            <button
              type="button"
              className="icon-btn icon-btn--subtle history__remove"
              onClick={() => onRemove(entry)}
              aria-label={`„${entry.title || entry.videoId}“ aus dem Verlauf entfernen`}
              title="Aus dem Verlauf entfernen"
            >
              <X size={18} aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
